<template>
  <!-- <NuxtPage :keepalive="{ max: 5 }" /> -->
  <NuxtPage />
</template>

<script setup lang="ts">
const { dir, lang } = useAppLocale();

useHead(() => ({
  htmlAttrs: {
    lang: lang.value,
    dir: dir.value,
  },
}));
</script>
